/** sessionStorage flag: user landed via Supabase signup/email confirm tokens (often on `/` + hash). */
export const EMAIL_CONFIRM_NAV_FLAG = 'bcc_email_confirm_to_login';
